export const sendEcEvent = (name, params) => {
    if (!name) {
        return;
    }

    if (window.AnalyticsWebInterface) {
        // Call Android interface
        window.AnalyticsWebInterface.logECEvent(name, JSON.stringify(params));
    } else if (
        window.webkit
        && window.webkit.messageHandlers
        && window.webkit.messageHandlers.firebase
    ) {
        // Call iOS interface
        const message = {
            command: 'logECEvent',
            name,
            parameters: params
        };
        window.webkit.messageHandlers.firebase.postMessage(message);
    }
};
